module.exports = __webpack_public_path__ + "img/logo_coinabout.65ec8a99.svg";